"use client";

import { useEffect, useState } from "react";
import { Row, Col, Card, Spinner } from "react-bootstrap";
import { getStoreProfile, getSalesSummary } from "../../services/store";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const StoreDashboardComp = () => {
  const [profile, setProfile] = useState(null);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [me, sales] = await Promise.all([
          getStoreProfile(),
          getSalesSummary(),
        ]);
        setProfile(me);
        setSummary(sales);
      } catch (err) {
        console.error("Error loading store dashboard:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
        <p className="mt-3">در حال بارگذاری اطلاعات...</p>
      </div>
    );
  }

  return (
    <>
      {/* Welcome Box */}
      <Card className="bg-primary border-0 rounded-3 welcome-box mb-4">
        <Card.Body className="p-4">
          <Row className="align-items-center">
            <Col xs={12} sm={8} lg={8}>
              <div className="border-bottom mb-3">
                <h3 className="text-white fw-semibold mb-1">
                  سلام، <span className="text-danger-div">{profile?.storeName || "فروشگاه شما"}</span>
                </h3>
                <p className="text-light mb-0">خلاصه عملکرد امروز شما</p>
              </div>

              <div className="d-flex align-items-center flex-wrap gap-4 gap-xxl-5">
                <div className="d-flex align-items-center welcome-status-item">
                  <div className="flex-shrink-0"> 
                    <i className="material-symbols-outlined">account_balance_wallet</i>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <h5 className="text-white fw-semibold mb-0">
                      {summary?.balance?.toLocaleString() || 0} تومان
                    </h5>
                    <p className="text-light mb-0">موجودی کیف پول</p>
                  </div>
                </div>

                <div className="d-flex align-items-center welcome-status-item">
                  <div className="flex-shrink-0"> 
                    <i className="material-symbols-outlined icon-bg">list_alt</i>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <h5 className="text-white fw-semibold mb-0">{summary?.pendingRequests || 0}</h5>
                    <p className="text-light mb-0">درخواست‌های در انتظار</p>
                  </div>
                </div>

                <div className="d-flex align-items-center welcome-status-item">
                  <div className="flex-shrink-0"> 
                    <i className="material-symbols-outlined icon-bg">point_of_sale</i>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <h5 className="text-white fw-semibold mb-0">{summary?.todaySales || 0}</h5>
                    <p className="text-light mb-0">فروش امروز</p>
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} sm={4} lg={4}>
              <div className="welcome-img text-center text-sm-end mt-4 mt-sm-0">
                <img
                  src="/images/welcome.png"
                  alt="welcome"
                  width={209}
                  height={168}
                />
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Sales Chart */}
      <Card className="border-0 rounded-3 mb-4">
        <Card.Body>
          <h5 className="fw-semibold mb-3">نمودار فروش هفتگی</h5>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={summary?.weeklySales || []}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="amount" stroke="#0d6efd" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </Card.Body>
      </Card>
    </>
  );
};

export default StoreDashboardComp;
